import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import { GLOBAL_MEETING_DATA } from "../../../../constants/PublicVariables";
import waitingScreenService from "../../../../services/waitingScreenService";
import { handleEndCallFunc } from "../../../Twilio/Room/roomFunction";
import useLanguageChange from "../../../../hooks/useLanguageChange";
import { poweredBy } from "../../../../constants/Constants";

const WaitingScreen = ({ localisedValuesForCallBody }) => {
    const { waitingBarWidth } = useSelector((state) => state.commonReducer);
    const localisedValues = useLanguageChange();

    useEffect(() => {
        waitingScreenService.showProgressBar(true);
    }, []);

    useEffect(() => {
        if (waitingBarWidth === 100) {
            handleEndCallFunc(); // end call API
        }
    }, [waitingBarWidth]);

    return (
        <div className='call-progress' data-testid='waitingScreen'>
            <div className='call-progress-in'>
                {GLOBAL_MEETING_DATA.companyLogo && (
                    <div className='domain-logo'>
                        <img className='domain-img' src={GLOBAL_MEETING_DATA.companyLogo} alt='' />
                    </div>
                )}
                <div className='call-progress-bar'>
                    <div className='call-progress-base'>
                        <div className='call-progress-fill' style={{ width: waitingBarWidth + "%" }}></div>
                    </div>
                </div>
                <div className='call-waiting-text'>{localisedValuesForCallBody?.connecting_your_call}</div>
                {GLOBAL_MEETING_DATA.getIsSpeedTestLinkAvailableData?.isVisible &&
                    GLOBAL_MEETING_DATA.getIsSpeedTestLinkAvailableData?.waitingScreenLinkHtml}
            </div>
            {GLOBAL_MEETING_DATA.getIsPoweredByAvailable && (
                <div className='poweredby-box'>
                    <span className='for-text'>{localisedValues?.powered_by} </span>
                    <a className='for-link' href={poweredBy} target='_blank'>
                        Blitzz
                    </a>
                </div>
            )}
        </div>
    );
};

WaitingScreen.propTypes = {
    localisedValuesForCallBody: PropTypes.object.isRequired,
};

export default WaitingScreen;
